let language = {
    ORDER_BILL_TOTAL_WEIGHT: "总重量:",
    ORDER_BILL_SUBTOTAL: "小计:",
    ORDER_BILL_TAX: "税费:",
    ORDER_BILL_SHIPPING_FEE: "运费:",
    ORDER_BILL_IMPORT_SERVICE_FEE: "进口服务费",
    ORDER_BILL_TOTAL: "应付金额:",
};

export { language }
